import { render, staticRenderFns } from "./Teach.vue?vue&type=template&id=d35cad6e&scoped=true&"
import script from "./Teach.vue?vue&type=script&lang=js&"
export * from "./Teach.vue?vue&type=script&lang=js&"
import style0 from "./Teach.vue?vue&type=style&index=0&id=d35cad6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35cad6e",
  null
  
)

export default component.exports